export const featureLocaleOverrides = {
  en: {
    nav: {
      batch_collections: 'Collect Payments',
    },
    controlSpending: {
      table: {
        name: 'To/From',
        date: 'Date&Time',
      },
    },
    ibanSwiper: {
      labels: {
        multiple_currencies: 'EUR and GBP',
      },
    },
    totalBalance: {
      promo: {
        title: 'Order an additional card',
      },
    },
  },
};
